module.exports = __webpack_public_path__ + "img/Sibiu_7_kl.096309b2.jpg";